import type { ZabitBridge } from '../../renderer/src/global';

/**
 * Bildirimler — yalnızca mobil uygulamada (mobile/src/shims/pushNotifications.ts).
 * Web'de yok.
 */
export const pushNotifications: ZabitBridge['pushNotifications'] = undefined;

/** Çıkıştan hemen önce, oturum hâlâ açıkken. Web'de yapılacak bir şey yok; mobilde cihaz kaydı silinir. */
export async function beforeSignOut(): Promise<void> {}
